import util from './util'
import Api from 'api/api'
import i18nUtil from 'utils/i18n'
import { Loading } from 'hui'
import store from '../store'

export const ErrorHandleMixin = {
  methods: {
    _handleError (error) {
      if (error.message) {
        error.msg = error.message
      }
      if (error.msg && error.msg !== '') {
        this.$message.error(error.msg)
      } else if (error.errorCode !== 'pleaseRefreshByHeader') {
        this.$message.error(this.$t('common.sys_error'))
      }
    }
  }
}

/*
 * 计算表格高度mixin
 * ①在table控件上添加: 值为‘fixed-table’的class
 * ②在table控件上添加: ':height="mixinTableHeight"'
 * ③在组建中引入mixin: mixins: [fixedTableMixin],
 * */
export const fixedTableMixin = {
  data () {
    return {
      mixinTableHeight: null,
      setTableHeightDebounce: null
    }
  },
  methods: {
    // 计算表格高度
    setTableHeight () {
      this.$nextTick(() => {
        this.mixinTableHeight = util.getWrapperContentHeight('.fixed-table')
      })
    }
  },
  created () {
    this.setTableHeightDebounce = this.$lodash.debounce(
      this.setTableHeight,
      150
    )
  },
  mounted () {
    this.$nextTick(() => {
      this.setTableHeight()
    })
    window.addEventListener('resize', this.setTableHeightDebounce)
    // window.onresize = this.$lodash.debounce(this.setTableHeight, 150);
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setTableHeightDebounce)
  }
}

/*
 * 用于修复分页器，当总记录数为0时，页数输入框中显示为1的问题
 * _fixedPage 参数1：当前数据总条数，参数2：分页器组件的引用
 * 1.在加载表格完成之后，调用_fixedPage
 * 2.在加载表格出错之后，将总数设置为0，然后调用_fixedPage
 * 3.在mounted的钩子函数中调用，如果total以及引用的变量不对，请在组件内部的mounted中，手动调用
 * */
export const paginationFixedMixin = {
  methods: {
    _fixedPage (total, ref) {
      if (total === 0 && ref) {
        let _editor = ref.$el.querySelector('.el-pagination__editor')
        if (_editor) {
          this.$nextTick(() => {
            _editor.value = 0
          })
        }
      }
    }
  },
  mounted () {
    this._fixedPage(this.pagination.total, this.$refs.pagination)
  }
}

/*
 * 用于创建Loading遮罩层
 * */
export const LoadingMixin = {
  methods: {
    _getLoading () {
      return Loading.service({
        target: this.$refs.container,
        text: this.$t('common.loading_text')
      })
    }
  }
}

/*
 * 用于加载设置语言的Mixin
 * */
export const LanguageMixin = {
  methods: {
    _setDefaultLanguage () {
      let _language = this.$storage.get('portal_language')
      Api.common.basicInfo({ language: _language }).then(res => {
        if (res.data.language) {
          _language = res.data.language
        }
        i18nUtil.setLanguage(_language)
      })
    }
  },
  mounted () {
    this._setDefaultLanguage()
  }
}

/*
 * 用于验证图片地址是否正确，如果不正确替换成空地址，防止IE下报错
 * */
export const ValidatePicUrlMixin = {
  methods: {
    _validatePicUrl (src) {
      let imgObj = new Image()
      imgObj.src = src
      if (imgObj.fileSize > 0 || (imgObj.width > 0 && imgObj.height > 0)) {
        return src
      } else {
        return ''
      }
    }
  }
}

/*
date 2019-01-21
author zhangzhitao
*/
// 用于监听各个弹窗出现时，弹窗的上下左右位置
export const CoverVideo = {
  methods: {
    _coverVideo (params) {
      let targetFrame =
        document.getElementById(`iframe${store.state.activeTabMenu}`) ||
        document.getElementById('iseframe')
      let dropDom =
        document.getElementById(params) || document.getElementsByName(params)[0]
      setTimeout(() => {
        let argus = ''
        let msg
        if (dropDom) {
          let _dom = dropDom.getBoundingClientRect()
          // 发给1903视频控件
          argus = {
            servFlag: 'tipSize',
            data: {
              left: _dom.left,
              right: _dom.right,
              top: _dom.top,
              bottom: _dom.bottom,
              width: _dom.width,
              height: _dom.height
            }
          }
          msg = {
            method: 'showContentOverTool',
            argument: {
              isExtend: _dom.width > 0 && _dom.height > 0, // true表示需要切割控件
              target: params, // 考虑到控件上可能需要显示不止一块内容，故给每个下拉框等dom设置了一个名称
              pos: {
                left: _dom.left,
                right: _dom.right,
                top: _dom.top,
                bottom: _dom.bottom,
                width: _dom.width,
                height: _dom.height
              }
            }
          }
        }
        let data = JSON.stringify(argus)
        if (targetFrame) {
          targetFrame.contentWindow.postMessage(JSON.stringify(msg), '*')
          targetFrame.contentWindow.postMessage(data, '*')
        }
      }, 500)
    }
  }
}

export const resizeFrame = {
  methods: {
    _resizeFrame () {
      let rightWrapper = document.getElementById('rightWrapper')
      let rect
      if (rightWrapper) {
        rect = rightWrapper.getBoundingClientRect()
      }
      let msg = {
        method: 'resizeIframeCallback',
        argument: {
          pos: {
            top: rect.top,
            left: rect.left,
            width: document.body.offsetWidth,
            height: rect.height
          }
        }
      }
      let argus = JSON.stringify(msg)
      for (let i = 0; i < window.frames.length; i++) {
        window.frames[i].postMessage(argus, '*')
      }
    }
  }
}

export const autoCloseMenu = {
  methods: {
    _autoCloseMenu (param) {
      window.addEventListener('resize', () => {
        let app = document.getElementById('app')
        if (app.offsetWidth && app.offsetWidth < 1462) {
          this.isCollapse = true
        } else {
          this.isCollapse = false
        }
      })
    }
  }
}

export const judgeHasMenu = {
  methods: {
    judgeHasMenu (value, key) {
      const findMenu = function (arr, value, key) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i][key] === value) {
            return arr[i]
          }
          if (arr[i]._hasChild) {
            let _res = findMenu(arr[i].children, value, key)
            if (_res) return _res
          }
        }
        return null
      }
      const temp = findMenu(this.$store.state.appMenus, value, key)
      return !!temp
    }
  }
}

export const keepAlive = {
  methods: {
    keepAlive () {
      setInterval(() => {
        Api.common
          .getAbout()
          .then(res => { })
          .catch(err => {
            this.$message.error(err.msg)
          })
      }, 1200000)
    }
  }
}

export const getQueryString = {
  methods: {
    getQueryString (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      }
      return null
    }
  }
}
